import React, { useEffect, useRef } from 'react';

import cx from 'classnames';
import { useDispatch } from 'react-redux';

import MediaItem from 'components/shared/MediaItem';
import { viewThunk } from 'store/assets/thunks';

import styles from './index.module.css';
import ReorderableBlocks from './ReorderableBlocks';
import wrap from './wrap';

const MediaBlocks = (props) => {
  const {
    placeholder,
    assets = [],
    onClick,
    onLoadChunk,
    onDelete,
    sm = false,
    onReorder,
    onCheckUpdatable,
    imageSizeType,
    scrollableContainerRef,
  } = props;
  const ref = useRef();
  const loadingRef = useRef(false);
  const isNoData = Boolean(assets.length === 0 && placeholder);
  const dispatch = useDispatch();

  useEffect(() => {
    const elem = scrollableContainerRef?.current;
    if (!elem) {
      return;
    }

    const needToRefresh = () => elem.scrollHeight - elem.scrollTop - elem.clientHeight < 200;

    const fn = async () => {
      if (isNoData) return;
      if (loadingRef.current) return;

      if (!needToRefresh()) return;
      else loadingRef.current = true;

      if (onLoadChunk) await onLoadChunk();

      loadingRef.current = false;
    };

    elem.addEventListener('scroll', fn);
    if (needToRefresh()) fn();

    return () => {
      elem.removeEventListener('scroll', fn);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current, loadingRef]);

  if (isNoData) {
    return <div className={styles.noDataContainer}>{placeholder}</div>;
  }

  const renderAsset = (asset) => (
    <MediaItem
      key={asset.id}
      id={asset.id}
      onEdit={asset?.policies?.update && wrap(onClick, asset)}
      onDelete={asset?.policies?.destroy && wrap(onDelete, asset)}
      onClick={wrap(() => dispatch(viewThunk({ id: asset.id })))}
      updatable={onCheckUpdatable(asset)}
      imageSizeType={imageSizeType}
      imageCoords={asset.imageCoords}
      type={asset.type}
      url={asset.url}
      name={asset.name}
      versionsProcessingStatus={asset?.versionsProcessingStatus}
    />
  );

  return (
    <div className={cx(styles.container, sm && styles.containerSm)} ref={ref} data-e2e-widget-type="pageContent">
      {onReorder && <ReorderableBlocks {...props} renderAsset={renderAsset} />}
      {!onReorder && assets.map(renderAsset)}
    </div>
  );
};

export default MediaBlocks;
